module.exports = __webpack_public_path__ + "static/media/visaCard.7f01d326.jpg";